<nav class="nav fixed-top p-3 justify-content-center"
style="background-image: url('assets/img/h1_hero.png');
              background-repeat: no-repeat;
                background-attachment: fixed;
      background-position: center; 
       background-size: cover;
            "
            >
    <a class="nav-link" routerLink="/">Home</a>
    <a class="nav-link" routerLink="/aplikasi">Applikasi</a>
    <a class="nav-link" routerLink="/website">Website</a>
    <a class="nav-link" routerLink="/axcoraschool">ERP</a>
  </nav>

<div class="container-fluid">
<div class="row">
    <div class="col-12 col-md-12 p-3 p-md-5 text-center text-white"
    style="background-image: url('assets/img/h1_hero.png');
              background-repeat: no-repeat;
                background-attachment: fixed;
      background-position: center; 
       background-size: cover;
            "
            >
        <img src="assets/img/logo.png" alt="aplikasi belajar online"/><br/>    
    <img class="img-fluid rounded-circle" src="assets/img/aplikasisekolah online web app (15).jpg" alt="aplikasi belajar e-learing online gratis"/><br/>
    <h3><strong><a class="text-white" href="https://axcoraschool.vercel.app">Aplikasi Pembayaran Sekolah</a></strong></h3>
<p class="text-white">
    Aplikasi yang dipergunakan dalam kebutuhan untuk keuangan sekolah dan mencatat pembayaran secara detail.<br/>Dengan online web app memudahkan nya dalam kebutuhan untuk akses dan bekerja dengan aplikasi ini via smartphone android iphone hingga pc desktop laptop windows dan berbagai OS lain nya, semakin mobile dengan web app <a href="https://axcoraschool.vercel.app">aplikasi pembayaran keuangan sekolah</a> ini .
</p>
<p class="text-white">
    Pelajari bagaimana aplikasi ini bekerja .
</p>  
<a class="btn btn-primary btn-lg rounded-pill" href="https://www.youtube.com/watch?v=MPSbEsWbIbc" target="_blank">Cek Demo Video</a>
</div>
<div class="col-12 col-md-12 p-3 p-md-5 text-center">
<img width="100%" class="img-fluid" src="assets/img/aplikasi pembayaran sekolah online brochure.jpg" alt="aplikasi keuangan sekolah online"/><br/>
<p>Simple dan mudah dalam penggunaan nya menggunakan apps ini, bekerja secara online real time membantu anda dalam setiap kebutuhan nya dalam bekerja secara cepat kapan saja dimana saja secara real time.</p>
<img width="100%" class="img-fluid" src="assets/img/aplikasi pembayaran sekolah online brochure1.jpg" alt="aplikasi keuangan sekolah online"/>
</div>
<div class="col-6 col-md-3 p-3 p-md-5 text-center text-white border border-white"
style="background-image: url('assets/img/h1_hero.png');
background-repeat: no-repeat;
background-position: center; 
"
>
<img class="img-fluid" src="assets/img/absensisekolah.png" alt="aplikasi keuangan sekolah online gratis website"/><br/>
<p class="text-white">Master data base akun pembayaran dan data siswa.</p>
</div>
<div class="col-6 col-md-3 p-3 p-md-5 text-center text-white border border-white"
style="background-image: url('assets/img/h1_hero.png');
background-repeat: no-repeat;
background-position: center; 
"
>
<img class="img-fluid" src="assets/img/media.png" alt="aplikasi pembayaran keuangan sekolah"/><br/>
<p class="text-white">Penerbitan invoice pembayaran dan kebutuhan keuangan.</p>
</div>
<div class="col-6 col-md-3 p-3 p-md-5 text-center text-white border border-white"
style="background-image: url('assets/img/h1_hero.png');
background-repeat: no-repeat;
background-position: center; 
"
>
    <img class="img-fluid" src="assets/img/pembayaransekolah.png" alt="aplikasi keuangan sekolah online gratis website"/><br/>
    <p class="text-white">Menu pembayaran keuangan include dengan cicilan system.</p>
</div>
<div class="col-6 col-md-3 p-3 p-md-5 text-center text-white border border-white"
style="background-image: url('assets/img/h1_hero.png');
background-repeat: no-repeat;
background-position: center; 
"
>
    <img class="img-fluid" src="assets/img/rapot.png" alt="aplikasi pembayaran keuangan sekolah"/><br/>
    <p class="text-white">Laporan detail keuangan dan income sekolah.</p>
</div>
<div class="col-12 col-md-4 p-3 p-md-5 text-center">
    <img class="img-fluid" src="assets/img/aplikasi pembayaran sekolah online brochure3.jpg" width="100%" alt="aplikasi pembayaran keuangan sekolah"/>
</div>    
<div class="col-12 col-md-4 p-3 p-md-5">
    <h3>Aplikasi keuangan dan pembayaran sekolah</h3>
<p>Aplikasi ini benar benar membantu dalam kebutuhan untuk keuangan sekolah dan pencatatan pembayaran secara detail dan terperinci.<br/>
    Kemudahan dalam cek transaksi outstanding belum terbayar hingga cek sisa credit cicilan jika melakukan pembayaran dengan cara cicilan semua menjadi dimudahkan dengan hadrinya program software pembayaran sekolah ini dalam penerapan nya.<br/>
Sangat mudah digunakan dan dapat diakses dari berbagai device semakin menyempurnakan system ini dalam bekerja.<br/>
Kini saat nya anda untuk menggunakan plugin applikasi ini dalam kebutuhan untuk keuangan dan pencatatan pembayaran.<br/>
<a href="https://www.youtube.com/watch?v=MPSbEsWbIbc" target="_blank" class="text-danger">cek demo nya disini →</a>
</p>
</div>
    <div class="col-12 col-md-4 p-3 p-md-5">
        <div class="bg-white border border-danger text-dark p-3 rounded">
            <h5 class="bg-danger text-white p-3 text-center">PLUGINS WEB</h5>
            <p>Plugin tambahan untuk paket website axcora school cms.</p>
            <p class="text-center border border-dark p-1"><strong>Rp.523.600/Tahun</strong></p>
        </div>
        <br/><br/>
        <div class="bg-white border border-primary text-dark p-3 rounded">
            <h5 class="bg-primary text-white p-3 text-center">NEW ORDER</h5>
            <p>Payment Apps
               , Free Domain .sch.id
               , Web Space 1.5GB
               , Include Host
               , <a routerLink="/cms" class="text-primary">axcora school cms →</a>
               , website sekolah
               , APK Android Guru
               , APK Android Siswa
            </p>
            <p class="text-center border border-dark p-1"><strong>Rp.2.512.300/Tahun</strong></p>
           <div class="text-center">
            <a href="https://wa.me/6285646104747?text=Axcoraschoolapps%20saya%20mau%20order%20Website%0ANama/Sekolah%20%3A%0AAlamat%20%3A%0APaketweb%20%3AAxcorapayment+schoolcms%0APrice%20%3ARp.2.512.300/tahun%0APembayaran%20via%20%3A%0ABCA%208290363021%20Rica%20Anggraini%0A%0Atolong%20diproses%20pesanan%20saya" class="btn card-btn1">Get Started</a>
        </div>
    </div>
    </div>

    </div></div>

  
    <div class="testimonial-area fix" >

    
    
        <div class="wantToWork-area ">
        <div class="container">
        <div class="wants-wrapper w-padding2 section-bg2" 
         style="background-image: url('assets/img/section_bg02.png');
                  background-repeat: no-repeat;
                    background-attachment: fixed;
          background-position: center; 
           background-size: cover;
                "
                >
        <div class="row align-items-center justify-content-center">
        <div class="col-xl-7 col-lg-9 col-md-8">
        <div class="wantToWork-caption text-center">
        <h2>ERP Sekolah</h2>
        <p>All in one system web app sekolah dalam satu applikasi super lengkap dalam kebutuhan proses belajar mengajar , e learning, absensi, hingga keuangan sekolah , agenda pengumuman berita sekolah include.
    <br/>
    Applikasi ERP sekolah dengan admin apps, guru pengajar apps, tata usaha dan keuangan apps, siswa murid apps, all in one integrasi dalam axcora school ERP untuk sekolah anda.
        </p>
        <a href="#" class="btn3 wantToWork-btn">Pelajari ERP Sekolah</a><br/><br/><br/><br/>
        </div>
        </div>
        </div>
        </div>
        </div>
        </div>
        
      </div>
